module.exports = "/assets/image-left@2x.jpg?fD+aaWX";